/* LUVA search. The whole catalogue is already in the markup, so filtering is local:
   no request, no loading state, a result on every keystroke.
   No dependencies. Re-runs for theme editor section reloads. */
(function () {
  'use strict';

  var REST_THRESHOLD = 4; // below this many matches, fill the card with the rest of the range

  function initSearch(header) {
    var panel = header.querySelector('[data-luva-search-panel]');
    var form = header.querySelector('[data-luva-search-form]');
    if (!panel || !form) return;

    var input = form.querySelector('[data-luva-search-input]');
    var countEl = form.querySelector('[data-luva-search-count]');
    var grid = panel.querySelector('[data-luva-search-grid]');
    var restWrap = panel.querySelector('[data-luva-search-rest]');
    var restGrid = panel.querySelector('[data-luva-search-restgrid]');
    var emptyEl = panel.querySelector('[data-luva-search-empty]');
    var eyebrow = panel.querySelector('[data-luva-search-eyebrow]');
    var glow = panel.querySelector('[data-luva-search-glow]');
    var scrim = header.querySelector('[data-luva-search-scrim]');
    var openBtn = header.querySelector('[data-luva-search-open]');
    var closeBtn = header.querySelector('[data-luva-search-close]');

    var tiles = [].slice.call(grid.querySelectorAll('.luva-search__tile'));
    var labels = tiles.map(function (t) { return t.querySelector('.luva-tile__name'); });
    var names = labels.map(function (l) { return l ? l.textContent : ''; });
    var allLabel = eyebrow ? eyebrow.textContent : '';
    var matchLabel = panel.getAttribute('data-match-label') || luvaT('search_matches', 'Matches');
    var cursor = -1;

    function esc(t) {
      return t.replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function highlight(name, q) {
      if (!q) return esc(name);
      var i = name.toLowerCase().indexOf(q);
      if (i < 0) return esc(name);
      return esc(name.slice(0, i)) + '<mark>' + esc(name.slice(i, i + q.length)) + '</mark>' + esc(name.slice(i + q.length));
    }

    function visible() {
      return [].slice.call(panel.querySelectorAll('.luva-search__tile:not([hidden])'));
    }

    function render(raw) {
      var q = (raw || '').trim().toLowerCase();
      var hits = [];
      var misses = [];

      for (var i = 0; i < tiles.length; i++) {
        var hay = tiles[i].getAttribute('data-search') || '';
        (q === '' || hay.indexOf(q) > -1 ? hits : misses).push(i);
        if (labels[i]) labels[i].innerHTML = highlight(names[i], q);
      }

      var none = q !== '' && hits.length === 0;

      if (none) {
        // Never a dead end: the whole wall comes back
        if (emptyEl) {
          emptyEl.hidden = false;
          emptyEl.innerHTML = '<b>' + (panel.getAttribute('data-empty-title') || 'Nothing matches') +
            ' “' + esc(raw.trim()) + '”</b><span>' +
            (panel.getAttribute('data-empty-note') || '') + '</span>';
        }
        hits = tiles.map(function (_, i) { return i; });
        misses = [];
        for (var k = 0; k < tiles.length; k++) if (labels[k]) labels[k].innerHTML = esc(names[k]);
      } else if (emptyEl) {
        emptyEl.hidden = true;
      }

      // Few matches leave the card looking empty, so the rest of the range fills it
      var showRest = !none && q !== '' && hits.length > 0 && hits.length < REST_THRESHOLD && misses.length > 0;

      hits.forEach(function (i) {
        tiles[i].hidden = false;
        if (tiles[i].parentNode !== grid) grid.appendChild(tiles[i]);
      });

      misses.forEach(function (i) {
        if (showRest) {
          tiles[i].hidden = false;
          if (tiles[i].parentNode !== restGrid) restGrid.appendChild(tiles[i]);
        } else {
          tiles[i].hidden = true;
          if (tiles[i].parentNode !== grid) grid.appendChild(tiles[i]);
        }
      });

      if (restWrap) restWrap.hidden = !showRest;
      if (eyebrow) eyebrow.textContent = (q !== '' && !none) ? matchLabel : allLabel;

      var filtered = q !== '' && !none;
      if (countEl) {
        countEl.textContent = filtered ? String(hits.length) : '';
        countEl.classList.toggle('is-on', filtered);
      }

      // The one slow moment: a light in the colour of the top match.
      // Typing is instant, the light takes 640ms. That difference is the point.
      if (glow) {
        var top = filtered ? tiles[hits[0]] : null;
        glow.style.setProperty('--tint', top ? top.getAttribute('data-colour') : '#2f7dff');
        glow.classList.toggle('is-on', !!top);
      }

      cursor = -1;
      paintCursor();
    }

    function paintCursor() {
      var v = visible();
      for (var i = 0; i < v.length; i++) v[i].classList.toggle('is-cursor', i === cursor);
      if (cursor > -1 && v[cursor]) v[cursor].scrollIntoView({ block: 'nearest' });
    }

    function open() {
      header.classList.add('is-searching');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      render('');
      setTimeout(function () { input.focus(); }, 120);
    }

    function close() {
      header.classList.remove('is-searching');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      input.value = '';
      render('');
      cursor = -1;
    }

    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (scrim) scrim.addEventListener('click', close);
    input.addEventListener('input', function () { render(input.value); });

    panel.addEventListener('click', function (e) {
      var b = e.target.closest('[data-luva-intent]');
      if (!b) return;
      input.value = b.getAttribute('data-luva-intent');
      render(input.value);
      input.focus();
    });

    // Enter without a highlighted tile submits the form, so real search still works
    form.addEventListener('submit', function (e) {
      var v = visible();
      if (cursor > -1 && v[cursor]) {
        e.preventDefault();
        window.location.href = v[cursor].getAttribute('href');
      }
    });

    header.addEventListener('keydown', function (e) {
      if (!header.classList.contains('is-searching')) return;
      var v = visible();
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); cursor = Math.min(cursor + 1, v.length - 1); paintCursor(); }
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); cursor = Math.max(cursor - 1, 0); paintCursor(); }
    });

    document.addEventListener('keydown', function (e) {
      var typing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName);
      if ((e.key === 'k' && (e.metaKey || e.ctrlKey)) || (e.key === '/' && !typing)) {
        e.preventDefault();
        header.classList.contains('is-searching') ? close() : open();
      }
    });
  }

  function init() {
    var header = document.getElementById('header-component');
    if (!header || header._luvaSearchInit) return;
    header._luvaSearchInit = true;
    initSearch(header);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () {
    var h = document.getElementById('header-component');
    if (h) h._luvaSearchInit = false;
    init();
  });
})();
